import React, {Component, ReactNode} from 'react'
import {AdminPageHeadingArea} from '../shared/pageBaseComponents/AdminPageHeadingArea'
import { Box, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {BackLink, StyledLink} from '../../styledComponents/adminPage/Links'
import styled from 'styled-components'
import {BelongCondominiumInfo} from '../../__NoAutomatedTests/components/login/repository/AdminUserLoginInfo'
import {Colors} from '../../styledComponents/Constants'
import DomainIcon from '@mui/icons-material/Domain'

interface Props {
    belongCondominiumInfoList: BelongCondominiumInfo[]
    handleCondominiumSelectButtonClick: (condominiumCd: string) => void
    handleCloseForCondominiumSelectDialog: () => void
}

export default class AdminAssocCondominiumSelectionDialogPc extends Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render(): ReactNode {
        const {belongCondominiumInfoList} = this.props

        return <>
            <SelectCondominiumDialogTitle>
                <AdminPageHeadingArea
                    title={'物件選択'}
                />
            </SelectCondominiumDialogTitle>
            <SelectCondominiumDialogContent>
                {
                    belongCondominiumInfoList.map((belongCondominiumInfo, index) => (
                        <Box key={index} mt={'24px'} mb={'24px'}>
                            <StyledLink
                                onClick={() => this.props.handleCondominiumSelectButtonClick(
                                    belongCondominiumInfo.condominiumCd)}
                            >
                                <LinkDomainIcon/>
                                <SelectCondominiumLinkText>
                                    {belongCondominiumInfo.condominiumName}
                                </SelectCondominiumLinkText>
                            </StyledLink>
                        </Box>
                    ))
                }
            </SelectCondominiumDialogContent>
            <SelectCondominiumDialogActions>
                <StyledBackLinkButton onClick={this.props.handleCloseForCondominiumSelectDialog}>
                    ログイン画面に戻る
                </StyledBackLinkButton>
            </SelectCondominiumDialogActions>
        </>
    }
}

const SelectCondominiumDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding-bottom: 0;
    }
`

const SelectCondominiumDialogContent = styled(DialogContent)`
    &.MuiDialogContent-root {
        margin-left: 16px;
        padding-top: 12px;
        padding-bottom: 0;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`
const LinkDomainIcon = withStyles({
    root: {
        color: Colors.AccentDark,
        fontSize: '24px',
    },
})(DomainIcon)

const SelectCondominiumLinkText = styled.span`
    margin-left: 12px;
    font-size: 16px;
`

const SelectCondominiumDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 24px 0 16px 16px;
    }
`

const StyledBackLinkButton = styled(BackLink)`
    font-size: 14px;
    margin-left: 16px;
`
